import React, { useState } from 'react';
import styled from 'styled-components';
import { Input, DatePicker } from 'antd';
import { ComponentEnum } from '../form';
import { UploadDocField } from '../uploadFile';
import moment from 'moment';

const { TextArea } = Input;

interface IProps {
  placeholder: string;
  style?: any;
  remark?: any;
  inputValue?: string;
  type?: string;
  defaultValue?: string;
  onChange?: (val: string) => void;
  value?: string;
}
interface IFile {
  filePath: string;
  fileName: string;
  fileFullPath?: string;
  url?: string;
}

const InputReset = (props: IProps) => {
  const [inputValue, setInputValue] = useState<string>(props?.defaultValue ?? '');

  const onChange = (e: any) => {
    setInputValue(e.target.value);
    props.onChange && props.onChange(e.target.value);
  };

  const changeDate = (date: any, dateString: any) => {
    console.log(date, dateString);
    setInputValue(dateString);
    props.onChange && props.onChange(dateString);
  };

  return (
    <Wrapper style={props.style}>
      {(props.inputValue || inputValue) && (
        <span className="title" style={{ marginTop: '5px' }}>
          {props.placeholder}
        </span>
      )}
      {(props.type === ComponentEnum.TEXT ||
        props.type === ComponentEnum.NUMBER ||
        props.type === ComponentEnum.PASSWORD) && (
        <Input
          defaultValue={props.defaultValue ?? ''}
          type={props.type}
          onChange={onChange}
          value={props.value}
          className="input"
          bordered={false}
          placeholder={props.placeholder}
        />
      )}
      {(props.type === ComponentEnum.URL || props.type === ComponentEnum.EMAIL) && (
        <Input
          //type={props.type}
          onChange={onChange}
          value={props.value}
          className="input"
          bordered={false}
          placeholder={props.placeholder}
        />
      )}
      {props.type === ComponentEnum.TEXT_AREA && (
        <TextArea
          onChange={onChange}
          value={props.value}
          className="input"
          bordered={false}
          autoSize={{ minRows: 1.5, maxRows: 1.5 }}
          placeholder={props.placeholder}
        />
      )}
      {props.type === ComponentEnum.DATE && (
        <>
          <DatePicker
            //bordered={false}
            style={{ borderBottom: '1px solid #cfd2e3' }}
            showTime
            value={props.value ? moment(props.value) : undefined}
            className="input"
            placeholder={props.placeholder}
            onChange={changeDate}
          />
        </>
      )}
      {props.type === ComponentEnum.TIME && (
        <DatePicker
          style={{ borderBottom: '1px solid #cfd2e3' }}
          //bordered={false}
          showTime
          value={props.value ? moment(props.value) : undefined}
          className="input"
          placeholder={props.placeholder}
          onChange={changeDate}
        />
      )}
      {props.type === ComponentEnum.DATE_TIME && (
        <div>
          <DatePicker
            style={{ borderBottom: '1px solid #cfd2e3' }}
            //bordered={false}
            value={props.value ? moment(props.value) : undefined}
            className="input"
            placeholder={props.placeholder}
            onChange={changeDate}
          />
        </div>
      )}
      {props.type === ComponentEnum.RADIO && (
        <Input
          //type={props.type}
          onChange={onChange}
          value={props.value}
          className="input"
          bordered={false}
          placeholder={props.placeholder}
        />
      )}
      {props.type === ComponentEnum.CHECKBOX && (
        <Input
          //type={props.type}
          onChange={onChange}
          value={props.value}
          className="input"
          bordered={false}
          placeholder={props.placeholder}
        />
      )}
      {<p style={{ position: 'absolute' }}>{props.remark}</p>}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  height: 90px;
  //border-bottom: 1px solid #cfd2e3;
  span.title {
    position: absolute;
    left: 11px;
    top: 0;
    color: #b7bacb;
  }
  p {
    margin-bottom: 0;
    margin-left: 11px;
    color: #b7bacb;
  }
  .input {
    width: 100%;
    height: 44px;
    margin: 20px auto 0 !important;
    color: #141c30;
    font-size: 14px;
    outline: none;
    border-bottom: 1px solid #cfd2e3;
    border-top: none;
    border-left: none;
    border-right: none;
    background: transparent;
    box-shadow: none;
  }
  .ant-input:hover {
    border-color: #cfd2e3 !important;
  }

  .ant-input:focus {
    border-color: #cfd2e3 !important;
  }
  input::placeholder {
    color: #b7bacb;
    font-size: 14px;
    opacity: 1 !important;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export default InputReset;
